import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useState } from "react";
import { renderClose } from "../../common/dialog";
import { createEntityStore } from "../../common/entityStore";
import { propDateField, propEnumField, propNumberField } from "../../common/entityStoreForm";
import { propInt, propMinValue, propRequired, propValidValue } from "../../common/entityStoreValidators";
import { useArticlesWithCode, useTransactionCodes, useWarehouses } from "../../common/enum";

export const InventoryTransactionDialog = (props: {
    close: () => void;
    inventoryTransaction: InventoryTransactionEditDto | null;
    onChange(): void;
}) => {
    const [useUserStore] = useState(() => createEntityStore<Partial<InventoryTransactionEditDto>>({
        data: {},
        path: "inventoryTransactions",
        id: props.inventoryTransaction != null ? props.inventoryTransaction.id : null,
        getNewId: p => p.id!,
        onSaved() {
            props.onChange();
            props.close();
        },
        propValidators: [
            propRequired("transactionCodeId"),
            propRequired("inventoryArticleId"),
            propValidValue("date", "dateFormatted"), propRequired("date"),
            propValidValue("qty", "qtyFormatted"), propRequired("qty"), propInt("qty"), propMinValue("qty", 1),
        ]
    }));

    const { save, entityId, isSaveDisabled } = useUserStore(p => ({ save: p.save, entityId: p.entityId, isSaveDisabled: p.isSaveDisabled }));
    return <>
        <DialogTitle>{entityId == null ? "New inventory transaction" : `Edit inventory transaction`}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2} alignItems="stretch">
                <Grid item xs={12}>{propEnumField(useUserStore)("transactionCodeId", "Transaction code", useTransactionCodes, { disabled: entityId != null })}</Grid>
                <Grid item xs={12}>{propEnumField(useUserStore)("inventoryArticleId", "Article", useArticlesWithCode, { disabled: entityId != null })}</Grid>
                <Grid item xs={6}>{propDateField(useUserStore)("date", "dateFormatted", "Transaction date")}</Grid>
                <Grid item xs={6}>{propNumberField(useUserStore)("qty", "qtyFormatted", "Quantity", { disabled: entityId != null })}</Grid>
                <Grid item xs={6}>{propEnumField(useUserStore)("fromWarehouseId", "From warehouse", useWarehouses, { disabled: entityId != null })}</Grid>
                <Grid item xs={6}>{propEnumField(useUserStore)("toWarehouseId", "To warehouse", useWarehouses, { disabled: entityId != null })}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={save} disabled={isSaveDisabled} color="save">Save</Button>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};

export interface InventoryTransactionEditDto {
    date: string;
    dateFormatted?: string;
    transactionCodeId: number;
    inventoryArticleId: number;
    fromWarehouseId: number | null;
    toWarehouseId: number | null;
    qty: number;
    qtyFormatted?: string;
    id: number;
}
